import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { legacy_createStore as createStore, applyMiddleware, compose } from "redux";
import { apiMiddleware } from "redux-api-middleware";
import { createAuthMiddleware } from "@tshio/redux-api-auth-middleware";
import { thunk } from "redux-thunk";
import { BrowserRouter as Router } from "react-router-dom";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import "./index.css";
import App from "./App";
import oAuthMiddleware from "./middleware/oauthMiddleware";
import passcodeMiddleware from "./middleware/passcodeMiddleware";
import billingMiddleware from "./middleware/billingMiddleware";
import projectmailMiddleware from "./middleware/projectmailMiddleware";
import rootReducer from "./reducers";
import { moment } from "./utils/LocalizedUtils";

const authMiddleware = createAuthMiddleware({
  authConfig: {
    header: "Authorization",
    type: "Bearer",
  },
});

const store = compose(
  applyMiddleware(
    authMiddleware,
    apiMiddleware,
    thunk,
    oAuthMiddleware,
    passcodeMiddleware,
    billingMiddleware,
    projectmailMiddleware
  )
)(createStore)(rootReducer);

const theme = createTheme();

const root = createRoot(document.getElementById("root"));
root.render(
  <ThemeProvider theme={theme}>
    <LocalizationProvider dateAdapter={AdapterMoment} dateLibInstance={moment}>
      <Router>
        <Provider store={store}>
          <App />
        </Provider>
      </Router>
    </LocalizationProvider>
  </ThemeProvider>
);
